webpackJsonp([5],{

/***/ "./install.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_unfetch__ = __webpack_require__("../../node_modules/unfetch/dist/unfetch.es.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



var $availableOS = document.querySelectorAll('.install-os-instructions');
var $selectedOS = document.getElementById('os');
var $selectedVersion = document.getElementById('version');
var $instructionsWrapper = document.getElementById('install-instructions');

function isValidOS(name) {
  return !!document.getElementById(name);
}

function showOS(name, version) {
  // Hide instructions for all operating systems
  for (var i = 0; i < $availableOS.length; i++) {
    $availableOS[i].style.display = 'none';
  }

  // Show just the instructions we need
  document.getElementById(name).style.display = 'block';
  $instructionsWrapper.className = 'install-' + version;

  if ($selectedOS.value !== name) {
    $selectedOS.value = name;
  }
  if ($selectedVersion.value !== version) {
    $selectedVersion.value = version;
  }
  history.replaceState(history.state, document.title, location.pathname + '#' + name + '-' + version);
}

function showSelectedOS() {
  showOS($selectedOS.value, $selectedVersion.value);
}

function showOSFromHash() {
  if (!location.hash) {
    return false;
  }

  var _location$hash$substr = location.hash.substr(1).split('-'),
      _location$hash$substr2 = _slicedToArray(_location$hash$substr, 2),
      os = _location$hash$substr2[0],
      version = _location$hash$substr2[1];

  if (!isValidOS(os)) {
    return false;
  }
  showOS(os, version || 'stable');
  return true;
}

function getNightlyVersionNumber() {
  Object(__WEBPACK_IMPORTED_MODULE_0_unfetch__["a" /* default */])('https://nightly.yarnpkg.com/latest-version').then(function (res) {
    return res.text();
  }).then(function (version) {
    document.getElementById('nightly-version').innerText = 'Classic Nightly (' + version + ')';
  });
}

function init() {
  getNightlyVersionNumber();
  $selectedOS.addEventListener('change', showSelectedOS, false);
  $selectedVersion.addEventListener('change', showSelectedOS, false);

  // If we're on a permalink to a particular OS and it's valid, show instructions
  // for that OS.
  if (showOSFromHash()) {
    return;
  }

  // Show the tab of the current OS. If we don't recognise the default OS,
  // default to Debian as an arbitrary popular choice.
  var osToSelect = [{ regex: /Windows/i, id: 'windows' }, { regex: /Mac OS/i, id: 'mac' }, { regex: /Linux|Ubuntu|Debian/i, id: 'debian' }].find(function (os) {
    return os.regex.test(navigator.userAgent);
  });
  showOS(osToSelect ? osToSelect.id : 'debian', 'stable');
}

init();

/***/ })

},["./install.js"]);


// WEBPACK FOOTER //
// install.0aedbee181c87b6124af.js